<script setup lang="ts">
defineProps({
  number: {
    type: Number,
    required: true,
  },
  supply: {
    type: Number,
    required: true,
  },
});
</script>
<template>
  <div class="px-7 border-b-2 border-primary-900 supply-section">
    <p class="text-primary-800 font-bold text-base">
      {{ $t("main.cardDetail.remainingOutOf") }}
      {{ number }}
      <span class="font-[Roboto] font-black">/</span>
      {{ supply }}
    </p>
  </div>
</template>

<!-- <style scoped>
.fancy {
  font-family: "Roboto", sans-serif;
}
</style> -->
